import { useQuery } from '@gogame/query';

import { loadDrillTo } from 'scenes/Trackers/Tracker/sources/table';

import { drillTo } from './queryKeyFactory';

export const useLoadDrillTo = (params) => {
  return useQuery(
    drillTo(params),
    (_, { signal }) => loadDrillTo(params, { signal }),
    {
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 5,
    }
  );
};
